import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import PokerTable from "./PokerTable";
import HandTable from "./HandTable";

const Poker = ({ userData, currencySymbol }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [activeSection, setActiveSection] = useState(() => {
    const params = new URLSearchParams(location.search);
    const gameId = params.get("game_id");
    return gameId ? "Hand Table" : "Poker Table";
  });
  const [handData, setHandData] = useState(() => {
    const params = new URLSearchParams(location.search);
    const gameId = params.get("game_id");
    return gameId ? { game_id: gameId } : null;
  });

  const handleSetActiveSection = (section) => {
    setActiveSection(section);
    if (section === "Poker Table") {
      setHandData(null);
      const params = new URLSearchParams(location.search);
      if (params.has("game_id")) {
        params.delete("game_id");
        const search = params.toString();
        navigate(
          `${location.pathname}${search ? `?${search}` : ""}`,
          { replace: true }
        );
      }
    }
  };

  return (
    <>
      {activeSection === "Poker Table" && (
        <PokerTable userData={userData} currencySymbol={currencySymbol} />
      )}
      {activeSection === "Hand Table" && (
        <HandTable
          userData={userData}
          handData={handData}
          setActiveSection={handleSetActiveSection}
          currencySymbol={currencySymbol}
        />
      )}
    </>
  );
};

export default Poker;
